// extracted by mini-css-extract-plugin
export default {"card4":"WJRDa2NP","image":"Eso6d8iT","content":"JBCVIUIb"};